import { DataColumn } from "./datacolumn.model";

export class DataSource{
   public id:number;
   public name:string;
   public dataColumns:Array<DataColumn>;
    

}